module.exports = __webpack_public_path__ + "static/media/repeat-1.0448b059.svg";